import { render, staticRenderFns } from "./bto-list.vue?vue&type=template&id=4583dfec&"
import script from "./js/bto-list.js?vue&type=script&lang=js&"
export * from "./js/bto-list.js?vue&type=script&lang=js&"
import style0 from "./bto-list.vue?vue&type=style&index=0&id=4583dfec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports